import script from "./employee-bulk-resend-password-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-bulk-resend-password-modal.vue?vue&type=script&setup=true&lang=js"

import "./employee-bulk-resend-password-modal.vue?vue&type=style&index=0&id=596b54fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-596b54fc"]])

export default __exports__